import React from "react";

/* ============================================================================
   BUILDING SYSTEM SYMBOLS
============================================================================ */

const BuildingSystemsSymbol = ({ family, color }) => {

  const base = {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  };

  switch (family) {

    case "foundations":
      return (
        <svg {...base}>
          <path d="M4 16h16"/>
          <path d="M7 16l2-5h6l2 5"/>
        </svg>
      );

    case "structure":
      return (
        <svg {...base}>
          <path d="M6 19V6"/>
          <path d="M18 19V6"/>
          <path d="M6 6h12"/>
        </svg>
      );

    case "floors":
      return (
        <svg {...base}>
          <path d="M4 8h16"/>
          <path d="M4 12h16"/>
          <path d="M4 16h16"/>
        </svg>
      );

    case "roofing":
      return (
        <svg {...base}>
          <path d="M4 12l8-6 8 6"/>
          <path d="M6 12v6h12v-6"/>
        </svg>
      );

    case "facades":
      return (
        <svg {...base}>
          <rect x="6" y="5" width="12" height="14"/>
          <path d="M10 5v14"/>
          <path d="M14 5v14"/>
        </svg>
      );

    case "openings":
      return (
        <svg {...base}>
          <rect x="6" y="7" width="12" height="10"/>
          <path d="M12 7v10"/>
        </svg>
      );

    case "stairs":
      return (
        <svg {...base}>
          <path d="M5 18h4v-3h3v-3h3V9h4"/>
        </svg>
      );

    case "partitions":
      return (
        <svg {...base}>
          <path d="M6 5v14"/>
          <path d="M12 5v14"/>
          <path d="M18 5v14"/>
        </svg>
      );

    case "floor_finishes":
      return (
        <svg {...base}>
          <path d="M5 8h14"/>
          <path d="M5 12h14"/>
          <path d="M5 16h14"/>
        </svg>
      );

    case "wall_finishes":
      return (
        <svg {...base}>
          <rect x="6" y="5" width="12" height="14"/>
          <path d="M6 10h12"/>
        </svg>
      );

    case "ceilings":
      return (
        <svg {...base}>
          <path d="M4 7h16"/>
          <path d="M8 7v5"/>
          <path d="M16 7v5"/>
        </svg>
      );

    case "external_works":
      return (
        <svg {...base}>
          <path d="M3 17h18"/>
          <path d="M7 17l2-4h6l2 4"/>
          <path d="M12 13v-3"/>
        </svg>
      );

    default:
      return (
        <svg {...base}>
          <rect x="5" y="5" width="14" height="14"/>
        </svg>
      );

  }
};

export default BuildingSystemsSymbol;